import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { RequisitesPayload } from 'Interfaces/Requisite';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((requisitesPayload: RequisitesPayload) =>
    $actions.requisite.createRequisites(dispatch, requisitesPayload),
  );
};
